import * as yup from 'yup';

export default yup.object().shape({
  name: yup.string()
    .required('Name is required'),
  tags: yup.array().of(yup.mixed()).default([]),
  sets: yup.array().of(yup.number()).default([]),
  category: yup.number().required('Category is required'),
  manufacturer: yup.mixed().optional().nullable(),
  images: yup.array().of(yup.object().shape({
    id: yup.number().required(),
    url: yup.string().required(),
    isNew: yup.boolean().notRequired(),
    created_at: yup.string().notRequired(),
  })).default([]),
  colors: yup.array().of(yup.string().optional()).default([]),
  count: yup.mixed().test(
    'maxDigitsAfterDecimal',
    'number field must have 2 digits after decimal or less',
    (value) => {
      if (value === '') {
        return true;
      }

      return /^\d+?$/.test(value);
    },
  ).notRequired(),
  storage: yup.mixed().optional().nullable(),
  barcode: yup.string()
    // .min(12, 'Barcode is too short')
    // .max(13, 'Barcode is too long')
    .optional()
    .default(null),
  price: yup.mixed().test(
    'maxDigitsAfterDecimal',
    'number field must have 2 digits after decimal or less',
    (value) => {
      if (value === '') {
        return true;
      }

      return /^\d+(\.\d{1,2})?$/.test(value);
    },
  ).notRequired(),
  note: yup.string().optional().default(null),
  // is_wishlisted: yup.boolean().default(false).nullable(),
});
